export enum MatchesCatalogComparator {
  MATCHES_CATALOG_DATA = 'MatchesCatalogData',
}
